import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  ReactNode,
} from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  DialogTitle,
  Slide,
  SlideProps,
} from "@mui/material";
import { WarningAmber } from "@mui/icons-material";

const Transition = forwardRef<HTMLDivElement, SlideProps>((props, ref) => (
  <Slide direction="up" timeout={500} ref={ref} {...props} />
));

type CustomDialogProps = {
  dialog: {
    title: string;
    context?: string | null;
    sx?: object;
  };
  children?: ReactNode;
  setData?: () => void;
};

export type CustomDialogHandle = {
  openDialog: () => void;
  closeDialog: () => void;
};

const CustomDialog = forwardRef<CustomDialogHandle, CustomDialogProps>(
  ({ dialog, children, setData }, ref) => {
    const [open, setOpen] = useState(false);

    useImperativeHandle(ref, () => ({
      openDialog: () => setOpen(true),
      closeDialog: () => setOpen(false),
    }));

    return (
      <Dialog
        open={open}
        disableScrollLock
        onClose={() => {
          setOpen(false);
          setData && setTimeout(() => setData(), 100);
        }}
        slots={{ transition: Transition }}
        disableEnforceFocus
        fullWidth
        slotProps={{
          paper: {
            sx: {
              width: "90vw",
              maxWidth: "900px",
              borderRadius: "22px",
              "&::-webkit-scrollbar": {
                width: "8px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "primary.main",
                borderRadius: "5px",
              },
            },
          },
        }}
        sx={{ width: "100%", height: "auto" }}
      >
        <DialogTitle>{dialog.title}</DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            px: 3,
            pb: dialog.context ? 1 : 0,
          }}
        >
          {dialog.context !== null && (
            <WarningAmber sx={{ paddingBottom: "5px" }} color="error" />
          )}
          <Typography sx={{ lineHeight: 1 }}>{dialog.context}</Typography>
        </DialogContent>{" "}
        <DialogActions sx={dialog.sx}>{children}</DialogActions>
      </Dialog>
    );
  }
);

export default CustomDialog;
